import ActivityTypes from '@/constants/ActivityTypes';
import useCustomHook from '@/hooks/useCustomHook';
import { ThemesContext } from '@/shared/ThemesContext/ThemesContext';
import { useContext, useEffect } from 'react';

export default function useThemeActivitiesSelector({
  theme,
  initialActivityIds,
  onActivitiesSelected,
}) {
  const themesContext = useContext(ThemesContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      selectedActivities: null,
      allActivities: [],
    },
    actions: {
      addSelectedActivity: (activity) => {
        const selectedActivities = [...state.selectedActivities, activity];
        actions.setState({
          selectedActivities,
        });
      },
      removeSelectedActivity: (activityId) => {
        const selectedActivities = state.selectedActivities.filter(
          (activity) => activity.id !== activityId
        );
        actions.setState({
          selectedActivities,
        });
      },
    },
  });

  useEffect(() => {
    if (themesContext.state.loaded && state.loading) {
      const completeTheme = themesContext.state.themes.find(
        (t) => t.id === theme.id
      );

      let selectedActivities = theme.activities || [];
      if (initialActivityIds) {
        selectedActivities = completeTheme.activities.filter((activity) =>
          initialActivityIds.includes(activity.id)
        );
      }
      actions.setState({
        loading: false,
        allActivities:
          completeTheme?.activities?.filter(
            (activity) => activity.type != ActivityTypes.realTime
          ) || [],
        selectedActivities,
      });
    }
  }, [themesContext.state.loaded, theme?.activities, initialActivityIds]);

  useEffect(() => {
    if (state.selectedActivities) {
      onActivitiesSelected(state.selectedActivities);
    }
  }, [state.selectedActivities]);

  return { state, actions };
}
